// AI Generated
import { Component, Input } from '@angular/core';
import { MonDialog } from '@client/app/modules/dialog-upgrade-wrapper/mon-dialog.service';
import { PipeService } from '@client/app/filters/pipe-transformation.service';
import { TrapFocusService } from '@client/app/modules/trap-focus/trap-focus.service';

@Component({
    selector: 'form-import-group-rules',
    templateUrl: './form-import-group-rules.component.html',
    standalone: false,
})
export class FormImportGroupRulesComponent {
    @Input() monDialogId: string = '';
    @Input() domainGroup: any;

    step: number = 1;
    saving: boolean = false;
    data: any = null;
    selected: any = {};

    constructor (
        private monDialog: MonDialog,
        private ng2PipeService: PipeService,
        private trapFocusService: TrapFocusService,
    ) {}

    ngOnInit () {
        this.step = 1;
        this.saving = false;
        this.data = null;
        this.selected = {};
        this.trapFocusService.pauseLast();
    }

    ngOnDestroy () {
        this.trapFocusService.unPauseLast();
    }

    submit () {
        this.saving = true;
        this.data.data.shift();

        for (let i = 0; i < this.data.data.length; i++) {
            if (this.data.data[i].length === 4) {
                this.domainGroup.rules.push({
                    match: this.data.data[i][0],
                    match_rule: this.data.data[i][1],
                    exclude: this.data.data[i][3].toLowerCase() === 'true',
                    text: this.data.data[i][2],
                });
            }
        }

        this.close();
    }

    close () {
        this.monDialog.close(this.monDialogId, this.domainGroup);
    }

    getSpinner () {
        if (this.saving) {
            return 'fa-spin ' + this.ng2PipeService.get('monIcons')(['SPINNER', 'ICON']);
        }
        return '';
    }
}
